__turbopack_context__.v({
  "background": "VideoPlayerYT-module-scss-module__QMmpgW__background",
  "centerPlayButton": "VideoPlayerYT-module-scss-module__QMmpgW__centerPlayButton",
  "embeddedEntry": "VideoPlayerYT-module-scss-module__QMmpgW__embeddedEntry",
  "fade-in": "VideoPlayerYT-module-scss-module__QMmpgW__fade-in",
  "foreground": "VideoPlayerYT-module-scss-module__QMmpgW__foreground",
  "headlineSandwich": "VideoPlayerYT-module-scss-module__QMmpgW__headlineSandwich",
  "heroVideo": "VideoPlayerYT-module-scss-module__QMmpgW__heroVideo",
  "iFrame": "VideoPlayerYT-module-scss-module__QMmpgW__iFrame",
  "image": "VideoPlayerYT-module-scss-module__QMmpgW__image",
  "isActive": "VideoPlayerYT-module-scss-module__QMmpgW__isActive",
  "isCentered": "VideoPlayerYT-module-scss-module__QMmpgW__isCentered",
  "isOpen": "VideoPlayerYT-module-scss-module__QMmpgW__isOpen",
  "playVideo": "VideoPlayerYT-module-scss-module__QMmpgW__playVideo",
  "root": "VideoPlayerYT-module-scss-module__QMmpgW__root",
  "textAlignLeft": "VideoPlayerYT-module-scss-module__QMmpgW__textAlignLeft",
  "transparent": "VideoPlayerYT-module-scss-module__QMmpgW__transparent",
  "videoOverlay": "VideoPlayerYT-module-scss-module__QMmpgW__videoOverlay",
  "videoOverlayBackdrop": "VideoPlayerYT-module-scss-module__QMmpgW__videoOverlayBackdrop",
  "videoOverlayClose": "VideoPlayerYT-module-scss-module__QMmpgW__videoOverlayClose",
  "videoOverlayCloseIcon": "VideoPlayerYT-module-scss-module__QMmpgW__videoOverlayCloseIcon",
  "videoOverlayInner": "VideoPlayerYT-module-scss-module__QMmpgW__videoOverlayInner",
  "videoOverlayInnerWrap": "VideoPlayerYT-module-scss-module__QMmpgW__videoOverlayInnerWrap",
  "videoPlayerYT": "VideoPlayerYT-module-scss-module__QMmpgW__videoPlayerYT",
});
